import React from "react";
var ImageCaption = function ImageCaption(_ref) {
    var caption = _ref.caption, customData = _ref.customData;
    return /*#__PURE__*/ React.createElement("div", {
        className: "absolute text-xs text-white",
        style: {
            right: "5px",
            bottom: "2px"
        }
    }, customData && customData.link ? /*#__PURE__*/ React.createElement("a", {
        href: customData.link,
        target: "_blank"
    }, caption) : caption);
};
export default ImageCaption;
